// src/auth/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { getAccessToken, getUser } from './tokenStorage';
import { processLoginSuccess } from './authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getUser() || null);
  const [accessToken, setAccessToken] = useState(getAccessToken() || null);
  //const [loading, setLoading] = useState(false);

  useEffect(() => {
    setUser(getUser());
    setAccessToken(getAccessToken());
  }, []);

  const login = useGoogleLogin({
    scope: 'openid email profile https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive.file',
    flow: 'implicit',
    onSuccess: async (tokenResponse) => {
      try {
        const userData = await processLoginSuccess(tokenResponse);
        setUser(userData);
        setAccessToken(tokenResponse.access_token);
      } catch (err) {
        console.error('Login processing failed:', err);
      }
    },
    onError: (err) => console.error('Login Failed:', err),
  });

  const logout = () => {
    // Using the service's logout to clear storage
    const { logout: serviceLogout } = require('./authService'); // or import at top
    serviceLogout();
    setUser(null);
    setAccessToken(null);
  };

  return (
    <AuthContext.Provider value={{ user, accessToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};